import styled from "styled-components";

export const InputFilesWrapper = styled.div`
  form {
    margin-top: 38px;
  }
  .ant-form-item-label label {
    font-size: 16px;
    font-weight: 400;
    line-height: 150%;
    color: var(--text-color, #1c1c1c);
  }
  .ant-select-selector {
    border-radius: 8px;
    border: 1px solid var(--border-color-secondary, #eaeaea) !important;
    background: var(--bg-color-secondary, #fafafa) !important;
    height: 56px !important;
  }
  .ant-select-arrow {
    height: 100%
  }

  .ant-select-selector .ant-select-selection-item,
  .ant-select-selector .ant-select-selection-placeholder {
    line-height: 53px !important;
    font-family: "PoppinsRegular", sans-serif !important;
  }
  .ant-select-item {
    padding: 16px !important;
  }

  .ant-form-item-explain {
    margin-top: 20px;
    margin-bottom: -20px;
  }

  .ant-form-item-has-feedback.ant-form-item-has-error .ant-select-selector {
    border-color: red !important;
  }

  .ant-form-item-has-feedback.ant-form-item-has-success .ant-select-selector .ant-select-selection-item-icon,
  .ant-form-item-has-feedback.ant-form-item-has-error .ant-select-selector .ant-select-selection-item-icon {
    display: none !important;
  }

  .ant-form-item-feedback-icon.ant-form-item-feedback-icon-error,
  .ant-form-item-feedback-icon.ant-form-item-feedback-icon-success {
    display: none !important;
  }

  .upload-row {
    margin-bottom: -1em;
  }

  /* The label row is a flex container so the field name sits on the left and
     the action icons (download / clear / upload) sit on the right — above
     the Select, never overlapping it. */
  .ant-form-item-label > label {
    width: 100%;
  }
  .ant-form-item-label > label::after {
    /* antd appends a colon spacer after the label text. With our flex row
       it shows up between the field name and the icons — kill it. */
    content: none !important;
  }
  .input-label-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    gap: 8px;
  }
  .input-label-actions {
    display: inline-flex;
    align-items: center;
    gap: 2px;
    flex-shrink: 0;
  }

  /* Single style for every action icon in the label row (download, clear,
     upload). Always visible when the field has the relevant state — the
     download/clear pair only renders when a file is selected, the upload
     button is always there. */
  .label-icon-btn {
    width: 24px;
    height: 24px;
    padding: 0;
    border: none;
    background: transparent;
    color: var(--text-color-muted, rgba(0, 0, 0, 0.45));
    font-size: 16px;
    line-height: 1;
    cursor: pointer;
    border-radius: 4px;
    transition: color 0.15s ease, background-color 0.15s ease;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
  .label-icon-btn:hover {
    color: var(--primary-color, #0c77dc);
    background-color: var(--hover-bg, rgba(12, 119, 220, 0.08));
  }
  .label-icon-btn:disabled {
    color: rgba(0, 0, 0, 0.25);
    cursor: not-allowed;
    background-color: transparent;
  }
`;
